<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h1 mat-dialog-title>Enter match results</h1>
<h2>{{ participant1?.name }} vs. {{ participant2?.name }}</h2>
<form class="form" [formGroup]="form" (ngSubmit)="updateQualificationMatchResults()">
  <div class="form-content" mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>Winner team</mat-label>
      <mat-select name="winnerTeam" formControlName="winnerTeam" [compareWith]="compareTeams">
        <mat-option [value]="participant1?.teamId">{{ participant1?.name }}</mat-option>
        <mat-option [value]="participant2?.teamId">{{ participant2?.name }}</mat-option>
      </mat-select>
      @if (form.controls.winnerTeam.invalid && form.controls.winnerTeam.errors?.['required']) {
        <mat-error>Winner team is required.</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Points achieved by winner team</mat-label>
      <input matInput formControlName="winnerPoints" name="winnerPoints" type="number" />
      @if (form.controls.winnerPoints.invalid && form.controls.winnerPoints.errors?.['required']) {
        <mat-error>Winner points is required.</mat-error>
      }
      @if (form.controls.winnerPoints.invalid && form.controls.winnerPoints.errors?.['min']) {
        <mat-error>Winner points can't be negative.</mat-error>
      }
      @if (form.controls.winnerPoints.invalid && form.controls.winnerPoints.errors?.['max']) {
        <mat-error>Winner points can't be larger than 128.</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-actions" mat-dialog-actions>
    <button
      mat-button
      data-cy="cancel-btn"
      color="warn"
      aria-label="Cancel entering match results"
      mat-dialog-close
    >
      Cancel
    </button>
    <button
      mat-flat-button
      data-cy="update-btn"
      color="primary"
      aria-label="Update match results"
      class="center-content"
      type="submit"
    >
      Update match results
    </button>
  </div>
</form>
